import { Box, Button, Container, Typography, useTheme } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function Unauthorized() {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Container
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box textAlign={"center"}>
        <Typography
          variant="h4"
          color={theme.palette.neutral[800]}
          fontWeight={900}
        >
          403
        </Typography>
        <Typography
          variant="h2"
          color={theme.palette.neutral[900]}
          fontWeight={900}
          sx={{ margin: "20px 0" }}
        >
          ممنوع الوصول
        </Typography>
        <Typography variant="body1" color={theme.palette.neutral[700]}>
          أنت لا تمتلك صلاحية للدخول إلى الصفحة!
        </Typography>
      </Box>
      <Button
        sx={{ fontWeight: "500", margin: "20px 0" }}
        variant="contained"
        onClick={() => navigate("/app/views")}
      >
        العودة إلى الصفحة الرئيسية
      </Button>
    </Container>
  );
}

export default Unauthorized;
